import React from "react";
import "./App.scss";
import { Footer, SideBar, TopNavBar } from "./components";
import { Box } from "@mui/material";
import { AppContextProvider } from "./context";
import { HomePage, ServicesPage } from "./pages";
import ServicePage from "./pages/Service/ServicePage";
import ContactPage from "./pages/Contact/ContactPage";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useScrollTop } from "./hooks";
import { AnimatePresence, motion } from "framer-motion";
import { HelmetProvider } from "react-helmet-async";

function App() {
  useScrollTop();
  const location = useLocation();

  const pageVariants = {
    initial: {
      opacity: 0,
      y: 20,
    },
    in: {
      opacity: 1,
      y: 0,
    },
    out: {
      opacity: 0,
      y: -20,
    },
  };

  const pageTransition = {
    type: "tween" as const,
    ease: "anticipate" as const,
    duration: 0.4,
  };

  return (
    <HelmetProvider>
      <AppContextProvider>
        <TopNavBar />
        <SideBar />
        <Box className="page-content">
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
            >
              <Routes location={location}>
                <Route path="/" element={<HomePage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/service/:serviceSlug" element={<ServicePage />} />
                <Route path="/contact-us" element={<ContactPage />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </motion.div>
          </AnimatePresence>
        </Box>
        <Footer />
      </AppContextProvider>
    </HelmetProvider>
  );
}

export default App;
